"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XyriasRegenerativeLoopAbilityHandler = exports.XyriasRegenerativeLoopActorAbilityFactory = exports.XyriasRegenerativeLoopAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class XyriasRegenerativeLoopAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.XyriasRegenerativeLoop;
        this.__typeName = "XyriasRegenerativeLoop";
    }
}
exports.XyriasRegenerativeLoopAbilityArgs = XyriasRegenerativeLoopAbilityArgs;
let XyriasRegenerativeLoopActorAbilityFactory = class XyriasRegenerativeLoopActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("XyriasRegenerativeLoop", "Self", 6);
    }
};
XyriasRegenerativeLoopActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("XyriasRegenerativeLoop")
], XyriasRegenerativeLoopActorAbilityFactory);
exports.XyriasRegenerativeLoopActorAbilityFactory = XyriasRegenerativeLoopActorAbilityFactory;
let XyriasRegenerativeLoopAbilityHandler = class XyriasRegenerativeLoopAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new __1.AttributeBasedHealingEffectArgs("XyriasRegenerativeLoop", __1.AttributeType.Health, 6),
            duration: Duration_1.Duration.Turns(4),
        });
    }
};
XyriasRegenerativeLoopAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.XyriasRegenerativeLoop)
], XyriasRegenerativeLoopAbilityHandler);
exports.XyriasRegenerativeLoopAbilityHandler = XyriasRegenerativeLoopAbilityHandler;
